import { render, staticRenderFns } from "./ShopDashboard.vue?vue&type=template&id=33df288c&"
import script from "./ShopDashboard.vue?vue&type=script&lang=js&"
export * from "./ShopDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShopDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports